import React from 'react';
import PropTypes from 'prop-types';
import { HiDocumentAdd } from 'react-icons/hi';
import Button from 'partial/components/Button';
import SectionHeader from 'partial/components/SectionHeader';
import GridCms from './GridCms';

const useCmsList = () => {
  const [list] = React.useState([
    {
      id: 1,
      label: 'Sit back & relax, shop online',
      photo_url: 'https://ucarecdn.com/81181694-5855-4d8c-a87c-8eba60fbc846/',
      description: 'Convenience at your  fingertips',
      url: 'https://marketplace-zalora-stg.multistore.asia',
      type: 'Web Url',
    },
    {
      id: 2,
      label: 'Are you hungry? Order online',
      photo_url: 'https://ucarecdn.com/b309f182-4bd6-4f94-842a-62ace1f1d46b/',
      description: 'Order food online.',
      url: 'https://www.mercato.group',
      type: 'Web Url',
    },
    {
      id: 3,
      label: 'Are you bored? Play online',
      photo_url: 'https://ucarecdn.com/b96a5e89-ad83-40d5-bc79-e49fec99b30c/',
      description: 'Play online games here on app.',
      url: 'https://stg.gamebox.ph/',
      type: 'Web Url',
    },
    {
      id: 4,
      label: 'Government services? Apply online',
      photo_url: 'https://ucarecdn.com/a53eec44-f330-4466-aa57-1e8f1cfc3dd8/',
      description: 'Stay up to date with your  contributions.',
      url: 'https://smarta-site.multisyscorp.io',
      type: 'Web Url',
    },
  ]);
  return [false, list];
};

function SliderSquareCms({ data, onSelect }) {
  const [isLoading, list] = useCmsList();
  const handleAdd = () => {
    console.log('handle add'); // eslint-disable-line
  };
  const handleSelect = (row) => {
    onSelect(row);
  };
  return (
    <>
      <div className="px-4 pt-5">
        <SectionHeader label={data.label}>
          <Button
            primary
            icon={HiDocumentAdd}
            onClick={handleAdd}
            disabled={isLoading}
          >
            Add
          </Button>
        </SectionHeader>
      </div>
      <div className="p-6">
        <GridCms
          isLoading={isLoading}
          data={list}
          labelKey="label"
          photoKey="photo_url"
          subKey="type"
          onSelect={handleSelect}
          size="lg"
          onAdd={handleAdd}
        />
      </div>
    </>
  );
}

SliderSquareCms.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SliderSquareCms;
